


















































































































































































































































































































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";
import ajax from "@/lib/ajax";

@Component({
  components: { draggable }
})
export default class extends AbpBase {
  @Prop() select: any;
  @Prop() eleItem: any;
  @Prop() eleIndex: number;
  @Prop() listdata: any;
  selectWidget: any = {};
  rendering = false; //标识远程数据源是否加载完成，解决select的下拉框内容不渲染的问题
  onlyDate =false;
  range =false;
  created() {
    this.selectWidget = this.select;
    if (!this.eleItem.maxlength) {
      this.eleItem.maxlength = null;
    }
    if(this.eleItem.datetype=='DatePicker'){
      this.onlyDate= true;
    }
    if(this.eleItem.datetype=='RangeDatePicker'){
      this.range= true;
    }
    this.getRemoteData();
  }

  // 读取下拉框的远程数据源
  async getRemoteData() {
    this.rendering = false;
    if (
      this.eleItem.isRemoteData &&
      this.eleItem.remoteDataUrl &&
      this.eleItem.remoteDataField
    ) {
      let url = `${XMLHTTP_BASEURL}/${this.eleItem.remoteDataUrl}`;
      let res;
      let payload = {};
      if (this.eleItem.remoteHttpPayload) {
        payload = JSON.parse(this.eleItem.remoteHttpPayload);
      }
      if (this.eleItem.remoteHttpMethod == "post") {
        res = await ajax.post(url, payload);
      } else {
        res = await ajax.get(url, { params: payload });
      }
      if (res.data.result && res.data.result.objects) {
        let remoteValueData = [];
        res.data.result.objects.forEach((item) => {
          if (item.hasOwnProperty(this.eleItem.remoteDataField)) {
            let val = item[this.eleItem.remoteDataField];
            remoteValueData.push({
              label: val,
              value: val,
            });
          }
        });
        this.eleItem.remoteValueData = remoteValueData;
      }
    }
    this.rendering = true;
  }

  // 点击不同的组件触发
  handleSelectWidget() {
    this.selectWidget = this.eleItem;
  }

  // 删除组件方法
  removeWidgetElement() {
    const index = this.eleIndex;
    if (this.listdata.list.length - 1 === index) {
      if (index === 0) {
        this.selectWidget = {
          key: null,
          placeholder: null,
        };
        console.log(this.eleItem);
      } else {
        this.selectWidget = this.listdata.list[index - 1];
      }
    } else {
      this.selectWidget = this.listdata.list[index + 1];
    }
    this.$nextTick(() => {
      this.listdata.list.splice(index, 1);
    });
  }

  @Watch("select")
  handleSelectChange(itemdata) {
    this.selectWidget = itemdata;
  }

  @Watch("selectWidget")
  handleSelectWidgetChange(data) {
    this.$emit("update:select", data);
  }
  setCalculation() {}
  setReset() {
    this.eleItem.defaultValue = "";
  }

  setDate() {
    console.log(this.eleItem);
    if (this.eleItem.datetype != "daterange") {
      this.eleItem.defaultValue = this.formatDateTime(this.eleItem.defaultValue);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/widgetFormItem.vue